export default __webpack_public_path__ + "static/media/white-cam-4.b444c181.png";